module.exports = __webpack_public_path__ + "assets_app/img/key_4.e68bc216.svg";